<template>
<div class="chapter">
<div class="inner_page">
<p class="sp2" id="epi"> </p>
<p class="FMEP">Nothing is so fatal to the progress of the human mind as to suppose our views of science are ultimate; that there are no new mysteries in nature; that our triumphs are complete; and that there are no new worlds to conquer.</p>
<div class="FMEPC-SP">
<p class="FMEPC">S<span class="ePub-SC">IR </span>H<span class="ePub-SC">UMPHRY </span>D<span class="ePub-SC">AVY</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?62c02c7a